import { api } from "./api";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    session: build.query<SessionApiResponse, SessionApiArg>({
      query: () => ({ url: `/v1/session` }),
    }),
    getFaqsByCategory: build.query<
      GetFaqsByCategoryApiResponse,
      GetFaqsByCategoryApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/content/faq/categories/${queryArg.categoryId}`,
      }),
    }),
    getCustomerDetails: build.query<
      GetCustomerDetailsApiResponse,
      GetCustomerDetailsApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/proxy/mijn-omgeving/customerDetails`,
        params: {
          ean: queryArg.ean,
          accountVendor: queryArg.accountVendor,
          alternateId: queryArg.alternateId,
          email: queryArg.email,
        },
      }),
    }),
    getInvoices: build.query<GetInvoicesApiResponse, GetInvoicesApiArg>({
      query: (queryArg) => ({
        url: `/v1/proxy/mijn-omgeving/invoices`,
        params: {
          accountId: queryArg.accountId,
          fromDate: queryArg.fromDate,
          toDate: queryArg.toDate,
        },
      }),
    }),
    getDocument: build.query<GetDocumentApiResponse, GetDocumentApiArg>({
      query: (queryArg) => ({
        url: `/v1/proxy/mijn-omgeving/document`,
        params: {
          documentId: queryArg.documentId,
          documentType: queryArg.documentType,
          alternateId: queryArg.alternateId,
        },
      }),
    }),
    postChangePaymentMethod: build.mutation<
      PostChangePaymentMethodApiResponse,
      PostChangePaymentMethodApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/proxy/mijn-omgeving/paymentMethod`,
        method: "PATCH",
        body: queryArg.paymentMethod,
      }),
    }),
    postChangeInvoiceCycle: build.mutation<
      PostChangeInvoiceCycleApiResponse,
      PostChangeInvoiceCycleApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/proxy/mijn-omgeving/invoiceCycle`,
        method: "PATCH",
        body: queryArg.invoiceCycle,
      }),
    }),
    getMeterReads: build.query<GetMeterReadsApiResponse, GetMeterReadsApiArg>({
      query: (queryArg) => ({
        url: `/v1/proxy/mijn-omgeving/meterReads`,
        params: {
          contractId: queryArg.contractId,
          fromDate: queryArg.fromDate,
          toDate: queryArg.toDate,
        },
      }),
    }),
    postMeterReads: build.mutation<
      PostMeterReadsApiResponse,
      PostMeterReadsApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/proxy/mijn-omgeving/meterReads`,
        method: "PATCH",
        body: queryArg.meterReads,
      }),
    }),
    getMeterReadTasks: build.query<
      GetMeterReadTasksApiResponse,
      GetMeterReadTasksApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/proxy/mijn-omgeving/meterReadTasks`,
        params: {
          taskId: queryArg.taskId,
        },
      }),
    }),
    getBudgetBillPlan: build.query<
      GetBudgetBillPlanApiResponse,
      GetBudgetBillPlanApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/proxy/mijn-omgeving/budgetBillPlan`,
        params: {
          accountId: queryArg.accountId,
        },
      }),
    }),
    postChangeMonthlyPayment: build.mutation<
      PostChangeMonthlyPaymentApiResponse,
      PostChangeMonthlyPaymentApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/proxy/mijn-omgeving/monthlyPayment`,
        method: "PATCH",
        body: queryArg.monthlyPayment,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as api };
export type SessionApiResponse = /** status 200 OK */ {
  isAuthenticated?: boolean;
};
export type SessionApiArg = void;
export type GetFaqsByCategoryApiResponse =
  /** status 200 A list of FAQs for the specified category. */ {
    /** The FAQ question. */
    question: string;
    /** The FAQ answer. */
    answer: string;
  }[];
export type GetFaqsByCategoryApiArg = {
  /** The ID of the category to retrieve FAQs for. */
  categoryId: string;
};
export type GetCustomerDetailsApiResponse =
  /** status 200 OK */ CustomerDetailsResponseModel[];
export type GetCustomerDetailsApiArg = {
  ean?: string;
  accountVendor?: string;
  alternateId?: string;
  email?: string;
};
export type GetInvoicesApiResponse =
  /** status 200 OK */ InvoiceResponseModel[];
export type GetInvoicesApiArg = {
  accountId: string;
  fromDate?: string;
  toDate?: string;
};
export type GetDocumentApiResponse = /** status 200 OK */ DocumentResponseModel;
export type GetDocumentApiArg = {
  documentId: string;
  documentType: string;
  alternateId?: string;
};
export type PostChangePaymentMethodApiResponse =
  /** status 200 OK */ ChangePaymentResponseModel;
export type PostChangePaymentMethodApiArg = {
  paymentMethod: PaymentMethod;
};
export type PostChangeInvoiceCycleApiResponse =
  /** status 200 OK */ InvoiceCycleResponseModel;
export type PostChangeInvoiceCycleApiArg = {
  invoiceCycle: InvoiceCycle;
};
export type GetMeterReadsApiResponse =
  /** status 200 OK */ MeterReadsResponseModel[];
export type GetMeterReadsApiArg = {
  contractId: string;
  fromDate?: string;
  toDate?: string;
};
export type PostMeterReadsApiResponse =
  /** status 200 OK */ PostMeterReadsResponseModel;
export type PostMeterReadsApiArg = {
  meterReads: MeterReads;
};
export type GetMeterReadTasksApiResponse =
  /** status 200 Status for every register on the meter */ CollectionStatusResource[];
export type GetMeterReadTasksApiArg = {
  taskId: string;
};
export type GetBudgetBillPlanApiResponse =
  /** status 200 OK */ BudgetBillPlanResponseModel;
export type GetBudgetBillPlanApiArg = {
  accountId: string;
};
export type PostChangeMonthlyPaymentApiResponse =
  /** status 200 OK */ ChangeMonthlyPaymentModel;
export type PostChangeMonthlyPaymentApiArg = {
  monthlyPayment: MonthlyPayment;
};
export type FinancialDetails = {
  status?: string;
  bankAccountNumber?: string;
  annualCollectionDate?: string;
  billingCycle?: number;
};
export type ContactAddressDetails = {
  city?: string;
  streetName?: string;
  houseNumber?: string;
  houseNumberExtension?: string;
  postalCode?: string;
};
export type ContactDetails = {
  title?: string;
  firstName?: string;
  middleName?: string;
  lastName?: string;
  suffix?: string;
  companyName?: string;
  contactType?: string;
  contactAddress?: ContactAddressDetails;
  phone?: string;
  altPhone?: string;
  email?: string;
  otherInfo?: string;
};
export type InvoiceAddressDetails = {
  city?: string;
  streetName?: string;
  houseNumber?: string;
  houseNumberExtension?: string;
  postalCode?: string;
};
export type LdcContractDetails = {
  id?: string;
};
export type AgreementDetails = {
  id?: string;
  startDate?: string;
  endDate?: string;
  signDate?: string;
};
export type StandardPeriodQuantitiesDetails = {
  amount?: number;
  significance?: string;
  unit?: string;
};
export type MasterDataDetails = {
  capacityTariffCode?: string;
  connectionStatus?: string;
  gridArea?: string;
  hasSmartMeter?: boolean;
  maxConsumption?: number;
  physicalStatus?: string;
  programPartyName?: string;
  startDate?: string;
  standardPeriodQuantities?: StandardPeriodQuantitiesDetails[];
  usageSegment?: string;
};
export type MeterDetails = {
  number?: string;
  StartDate?: string;
  meterType?: string;
};
export type ContractDetails = {
  totalUsageField?: string;
  ldcContract?: LdcContractDetails[];
  taskId?: number;
  active?: boolean;
  startDate?: string;
  endDate?: string;
  serviceType?: string;
  status?: string;
  agreement?: AgreementDetails;
  address?: ContactAddressDetails;
  masterData?: MasterDataDetails;
  meters?: MeterDetails[];
  accountId?: string;
  id?: string;
};
export type MandateDetails = {
  type?: string;
  signatureDate?: string;
};
export type AccountDetails = {
  financial?: FinancialDetails;
  budgetBillCounter?: number;
  contacts?: ContactDetails[];
  alertNote?: string;
  accountNumber?: string;
  customerId?: string;
  email?: string;
  credit?: number;
  deposit?: number;
  advancePayment?: number;
  invoiceAddress?: InvoiceAddressDetails;
  contracts?: ContractDetails[];
  mandates?: MandateDetails[];
  id?: string;
};
export type CustomerDetailsResponseModel = {
  customerType?: string;
  alternateId?: string;
  accounts?: AccountDetails[];
  firstName?: string;
  lastName?: string;
  birthDate?: string;
};
export type InvoiceResponseModel = {
  accountId?: string;
  creationDate?: string;
  dueDate?: string;
  id?: string;
  dueAmount?: number;
  totalAmount?: number;
  status?: string;
};
export type DocumentResponseModel = {
  Filename?: string;
  Stream?: string;
  Error?: string;
};
export type ChangePaymentResponseModel = {
  processId?: string;
  caseId?: string;
  error?: string;
};
export type PaymentMethod = {
  alternateId: string;
  accountId: string;
  nieuweIban: string;
  nieuweBetaalwijze: string;
};
export type InvoiceCycleResponseModel = {
  processId?: string;
  caseId?: string;
  error?: string;
};
export type InvoiceCycle = {
  alternateId: string;
  accountId: string;
  nieuweInvoiceCyle: string;
};
export type MeterReadsResponseModel = {
  quantity?: number;
  endDate?: string;
  startDate?: string;
  unit?: string;
  meterNumber?: string;
  beginReading?: number;
  endReading?: number;
  readingMethod?: string;
  significance?: string;
  dossierId?: string;
  referenceNumber?: string;
};
export type PostMeterReadsResponseModel = {
  processId?: string;
  caseId?: string;
  error?: string;
};
export type MeterReads = {
  /** AlternateId. */
  alternateId: string;
  /** AccountId. */
  accountId: string;
  /** LDCAccount. */
  ldcAccount: string;
  /** TaskId e.q. '2806011'. */
  taskId: string;
  /** Meter number e.q. '740181'. */
  meterNo: string;
  /** Date (yyyymmdd) e.q. '20240207'. */
  date: string;
  /** Counter reads e.q. '158.185'. */
  meterRead: string;
};
export type ServiceTypeResource =
  | "ELECTRICITY"
  | "GAS"
  | "HEAT"
  | "COLD"
  | "CHILLED_WATER"
  | "WATER"
  | "METER"
  | "NONE";
export type UnitResource =
  | "KWH"
  | "M3"
  | "HOUR"
  | "DAY"
  | "MONTH"
  | "YEAR"
  | "GJ"
  | "MJ"
  | "EUR"
  | "KWHH"
  | "GJC"
  | "MW";
export type CollectionStatusResource = {
  accountId?: string;
  contractId?: string;
  ldcAccountId?: string;
  eancode?: string;
  serviceType?: ServiceTypeResource;
  unitOfMeasure?: UnitResource;
  taskId?: number;
  event?: string;
  meterNumber?: string;
  numberOfDigits?: number;
  registerId?: number;
  dialNo?: number;
  significance?: string;
  previousRead?: number;
  previousReadDate?: string;
  expectedReadMin?: number;
  expectedReadMax?: number;
};
export type BudgetBillPlanResponseModel = {
  /** The current budget bill amount. */
  amount?: number;
  /** The maximum allowable budget bill amount. */
  maxAmount?: number;
  /** The minimum allowable budget bill amount. */
  minAmount?: number;
  /** The advised budget bill amount. */
  advisedAmount?: number;
  /** Additional comments related to the budget bill plan. */
  comment?: string;
  /** Indicates whether the budget bill plan amount is adjustable. */
  adjustable?: boolean;
};
export type ChangeMonthlyPaymentModel = {
  processId?: string;
  caseId?: string;
  error?: string;
};
export type MonthlyPayment = {
  alternateId: string;
  accountNo: string;
  accountId: string;
  nieuwTermijnBedrag: string;
};
export const {
  useSessionQuery,
  useGetFaqsByCategoryQuery,
  useGetCustomerDetailsQuery,
  useGetInvoicesQuery,
  useGetDocumentQuery,
  usePostChangePaymentMethodMutation,
  usePostChangeInvoiceCycleMutation,
  useGetMeterReadsQuery,
  usePostMeterReadsMutation,
  useGetMeterReadTasksQuery,
  useGetBudgetBillPlanQuery,
  usePostChangeMonthlyPaymentMutation,
} = injectedRtkApi;
